export const noOpFunction = (): void => {
  return;
};
